export const contextKey = 'no-op';
export const getWrapper = nextAction => (fnArgs, executionContext) =>
	nextAction(fnArgs, executionContext);
getWrapper.contextKey = contextKey;
